import merge from 'lodash/merge';
import clone from 'lodash/clone';
import isMobile from '../lib/isMobile';
import fluxDefaults from './defaultsLarge';
import squareWalls from './partials/squareWalls';

const mobile = isMobile();

module.exports = merge(
    clone(fluxDefaults, true),
    squareWalls,
    {
        movingWalls: [

        ],
        blobs: [
            // main blobs
            {
                x: '0%',
                y: '2%',
                width: '100%',
                height: mobile ? '22%' : '22%',
                color: [0, 0, 0, 255],
            },
            {
                x: '0%',
                y: '25%',
                width: '100%',
                height: mobile ? '3%' : '3%',
                color: [255, 0, 0, 255],
            },
            {
                x: '0%',
                y: '35%',
                width: '100%',
                height: mobile ? '3%' : '3%',
                color: [0, 255, 0, 255],
            },
            {
                x: '0%',
                y: '40%',
                width: '100%',
                height: mobile ? '3%' : '3%',
                color: [0, 0, 255, 255],
            },
        ],
    },
);



// WEBPACK FOOTER //
// ./js/flux/introDave.js